import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      border: '1px',
      borderColor: 'gray.300',
      color: 'beta.500',
      bg: 'gray.50',
      fontWeight: 'bold',
      caretColor: 'currentColor',

      '&&': {
        borderRightRadius: 'md',
        borderColor: 'beta.500',
        borderLeft: 'none',
        bg: 'alpha.800',
      },

      '&::placeholder': {
        color: 'gray.400',
      },

      _hover: {
        bg: 'gray.100',
        border: 'gray.400',
      },
      _focus: {
        border: '2px',
        borderColor: 'alpha.200',
        bg: 'gray.50',
        boxShadow: '0px 2px 8px 0px rgba(66, 153, 225, 0.45)',
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'black',
      fontSize: 'sm',
      color: '#441200',
      '&&': {
        bgGradient: 'linear(to-b, beta.400, beta.500)',
        borderLeftRadius: 'md',
        border: 'none',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          boxShadow: 'none',
          '&&': {
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {},
};
